import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'En dos semanas duplicamos las consultas. Los embudos ya venían armados, solo adaptamos el mensaje a nuestra clínica.',
  name: 'Camila Ferrer',
  role: 'Directora, Estudio Piel',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/96e0b97a-c25c-4d2e-9f93-1d75a7a3f27c.jpg'
}, {
  quote: 'La parte de IA me ahorra horas cada semana. Ahora publico todos los días sin depender de una agencia.',
  name: 'Martín Ríos',
  role: 'Fundador, Ríos Consultora',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/8fc2f53d-ddab-4337-8c53-19ae0939b4d6.jpg'
}, {
  quote: 'Es el nivel de diseño que esperaba de un estudio grande, pero con recursos que puedo editar yo misma.',
  name: 'Lucía Ortega',
  role: 'Marketing Lead, Nova Salud',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/555a19e3-56df-4567-94e7-16d9212681f0.jpg'
}];
export function Testimonials() {
  return <section className="relative w-full border-t border-white/[0.06] py-28 sm:py-32 lg:py-40" data-id="element-489" data-mp="m5b2xkhwlmg8">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-490" data-mp="78k3jb88caqm">
        <div className="max-w-2xl" data-id="element-491" data-mp="c6vcljqpah7s">
          <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-white/35" data-id="element-492" data-mp="c625uirqrrpn">
            Testimonios
          </p>
          <h2 className="mt-5 text-3xl font-semibold leading-tight tracking-[-0.02em] text-white sm:text-[2.6rem]" data-id="element-493" data-mp="zx7t3j00hm9z">
            Negocios que ya crecen con nosotros.
          </h2>
        </div>

        <ul className="mt-16 grid grid-cols-1 gap-6 lg:mt-20 lg:grid-cols-3" data-id="element-494" data-mp="q63dch2ihxe3">
          {TESTIMONIALS.map((t, i) => <motion.li key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex flex-col rounded-4xl bg-white p-9 shadow-[0_20px_60px_-30px_rgba(0,0,0,0.8)] sm:p-10" data-id="element-495" data-mp="v3mv3qyf4sas" data-mpi={i}>
              <div className="flex items-center gap-1" role="img" aria-label="5 de 5 estrellas" data-id="element-496" data-mp="1ofhor2cni5i7">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} aria-hidden="true" className="h-4 w-4 fill-[#8b5cf6] text-[#8b5cf6]" data-id="element-497" data-mp="1ekze1d8th9ow" data-mpi={s} />)}
              </div>
              <blockquote className="mt-7 flex-1 text-[15px] font-light leading-relaxed text-[#0d0d0f]/75" data-id="element-498" data-mp="10s9urgkoaivh">
                “{t.quote}”
              </blockquote>
              <div className="mt-8 flex items-center gap-3.5 border-t border-black/[0.07] pt-7" data-id="element-499" data-mp="vuq2vdv1y7l2">
                <img src={t.avatar} alt={`Retrato de ${t.name}`} className="h-11 w-11 rounded-full object-cover" loading="lazy" data-id="element-500" data-mp="qvn94pkivnse" />
                <div data-id="element-501" data-mp="3cf3l2y4mauef">
                  <p className="text-[14px] font-medium text-[#0d0d0f]" data-id="element-502" data-mp="3cek53myj2g31">
                    {t.name}
                  </p>
                  <p className="text-[12.5px] font-light text-[#0d0d0f]/50" data-id="element-503" data-mp="3gfdr2asetkta">
                    {t.role}
                  </p>
                </div>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}